<template>
  <div>
    <v-row class="ma-0" align="center">
      <v-col cols="12" lg="8" md="8" sm="6">
        <p>{{ $t("EVENTFORM.tabs.certificates.qt_hours") }}</p>
      </v-col>
      <v-col cols="12" lg="4" md="4" sm="6">
        <v-text-field
          v-model="hours"
          outlined
          dense
          class="pt-4"
          placeholder="hours"
          type="number"
        />
      </v-col>
    </v-row>
    <v-data-table
      id="participants-table"
      :items="usersWithPresence"
      :headers="
        headers.map((h) => ({
          ...h,
          text: h.text ? $t('EVENTFORM.tabs.certificates.' + h.text) : '',
        }))
      "
      :no-data-text="$t('EVENTFORM.tabs.participants.no_participants')"
      sort-by="name"
      :items-per-page="itemsPerPage"
      :hide-default-footer="participants.length <= itemsPerPage"
    >
      <template v-slot:[`header.actions`]="{ header }">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              icon
              :disabled="!participants || participants.length === 0"
              @click="
                hours.length != 0 ? sendCertificate(null) : (alert = true)
              "
              style="font-size: 0.7rem"
            >
              <v-icon color="blue">{{ mdiTextBoxMultiple }}</v-icon>
            </v-btn>
          </template>
          <span>{{ header.text }}</span>
        </v-tooltip>
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              @click="
                hours.length != 0 ? sendCertificate(item) : (alert = true)
              "
              v-on="on"
            >
              <v-icon>{{ mdiTextBox }}</v-icon>
            </v-btn>
          </template>
          <span>{{ $t("EVENTFORM.tabs.certificates.send_one") }}</span>
        </v-tooltip>
      </template>
    </v-data-table>
    <v-dialog v-model="alert" width="50%">
      <v-alert type="error" class="mb-0" dismissible v-model="alert">
        {{ $t("EVENTFORM.tabs.certificates.hours_required") }}
      </v-alert>
    </v-dialog>
  </div>
</template>

<script>
import { mdiTextBox, mdiTextBoxMultiple } from "@mdi/js";

export default {
  name: "ParticipantList",
  props: {
    participants: {
      type: Array,
      default: () => [],
      required: false,
    },
    eventName: {
      type: String,
    },
  },
  data() {
    return {
      headers: [
        { text: "name", value: "name" },
        { text: "email", value: "email" },
        {
          text: "send_to_all",
          value: "actions",
          sortable: false,
          align: "center",
        },
      ],
      itemsPerPage: 15,
      mdiTextBox,
      mdiTextBoxMultiple,
      selectedUsers: [],
      hours: "",
      day: "10",
      alert: false,
    };
  },
  computed: {
    usersWithPresence() {
      return this.participants.filter((p) => p.presence);
    },
  },
  methods: {
    getCertificatesPayload() {
      var certificates = [];

      this.selectedUsers.forEach((user) => {
        certificates.push({
          url: "certificate url",
          user: user,
          certificateName: this.eventName,
          data: {
            courseName: this.eventName,
            courseHours: this.hours,
            name: user.name,
          },
          type: "course-participant",
          date: this.day,
          generated: false,
        });
      });

      this.selectedUsers = [];

      return certificates;
    },
    sendCertificate(user) {
      if (user == null) this.selectedUsers = this.usersWithPresence;
      else this.selectedUsers.push(user);
      var payload = this.getCertificatesPayload(user);
      if (this.$store.dispatch("sendCertificate", payload)) {
        this.$store.dispatch("setSnackbar", {
          show: true,
          text: "Success on send Certificate!",
          color: "success",
        });
      } else {
        this.$store.dispatch("setSnackbar", {
          show: true,
          text: "Oops... Error on send Certificate",
          color: "error",
        });
      }
    },
  },
};
</script>

<style>
#participants-table .v-input__control > .v-input__slot {
  align-items: center !important;
  justify-content: center !important;
}

#participants-table
  .v-input__control
  > .v-input__slot
  > .v-input--selection-controls__input {
  margin: 0;
}
</style>
